import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import mapboxgl from 'mapbox-gl';
import classAbbreviations from './classCodes';
import accentInsensitiveSearch from 'accent-insensitive-search';
import {
    fitBoundsPadding,
    selectRegion,
    loadIndex,
    getRegionIndex,
} from './utils';
import { EventBus } from '../EventBus';

function zoomToRegionGroup(feature) {
    const bbox = feature.properties._bbox;

    window.leftmap.fitBounds(
        bbox,
        {
            padding: fitBoundsPadding(),
        },
        {
            moveSource: 'zoomToRegionGroup',
        }
    );
    if (window.geocoder.mapMarker) {
        window.geocoder.mapMarker.remove();
    }
}

function queryIndex(query) {
    function score({ properties: p }) {
        // function idx(field = '') {
        //     return (field || '').toLowerCase().indexOf(query.toLowerCase());
        // }
        function contains(field, atStart = false) {
            try {
                return accentInsensitiveSearch(
                    query.toLowerCase(),
                    (field || '').toLowerCase(),
                    { startWith: atStart }
                );
            } catch (e) {
                return (
                    query.toLowerCase().indexOf((field || '').toLowerCase()) >=
                    0
                );
            }
        }

        let score = 0;
        if (contains(p.Name_rgn, true)) {
            score += 10;
        } else if (contains(p.Name_rgn)) {
            score += 5;
        }
        if (contains(p.altname, true)) {
            score += 8;
        } else if (contains(p.altname)) {
            score += 4;
        }
        return score;
    }
    query = query.replace('’', "'");
    const results = getRegionIndex()
        .filter((f) => score(f) > 0)
        .map((f, i) => ({
            place_name: f.properties.Name_rgn,
            center: f.geometry.coordinates,
            place_type: 'place', //'region',
            text: f.properties.Name_rgn,
            id: i,
            geometry: f.geometry,
            properties: {
                ...f.properties,
                score: score(f),
                source: f.source,
            },
            source: f.source,
        }))
        .sort((a, b) => b.properties.score - a.properties.score);
    // console.log(results);
    return results;
}

function blurGeocoder() {
    window.setTimeout(
        () =>
            document
                .getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0]
                .blur(),
        1
    );
}

export function clearGeocoder() {
    geocoder.setInput('');

    /*
  // to prevent keyboard popping up
  document
      .querySelector('.mapboxgl-ctrl-geocoder--input')
      .setAttribute('readonly', true);
  try {
      geocoder.clear();

      blurGeocoder();
  } finally {
      document
          .querySelector('.mapboxgl-ctrl-geocoder--input')
          .removeAttribute('readonly');
  }
  */

    if (geocoder.mapMarker) {
        geocoder.mapMarker.remove();
    }
}

let geocoder;
export function addGeocoder(map, accessToken) {
    // console.log('**', accessToken);
    geocoder = new MapboxGeocoder({
        accessToken: accessToken,
        mapboxgl: mapboxgl,
        localGeocoder: queryIndex,
        localGeocoderOnly: window.location.hash.match(/dev/),
        zoom: 8,
        clearAndBlurOnEsc: true,
        types: 'country,region,district,place,locality',
        limit: 8,
        render: (item) => {
            if (!item.source) {
                return item.place_name;
            }
            const p = item.properties;
            const classClass = item.source || '';
            let out = `<span class="${classClass} region-title">${
                p.Name_rgn + (p.altname ? ' (' + p.altname + ')' : '')
            }</span>`;
            if (p.class) {
                out += `, <span class="class-field ${classClass}">${
                    classAbbreviations[p.class] || p.class
                }</span>`;
            }
            if (p.country) {
                out += `, <span class="state-country ${classClass}">${
                    p.state ? p.state + ', ' : ''
                }${p.country}</span>`;
            }
            return out;
        },
    });
    window.geocoder = geocoder;
    geocoder.on('result', ({ result }) => {
        if (result.source) {
            selectRegion(result);
        } else {
            selectRegion();
        }
        if (result.properties._bbox) {
            zoomToRegionGroup(result);
        }
        blurGeocoder();
    });

    geocoder.on('loading', () => EventBus.$emit('select-feature'));

    // leftmap.addControl(geocoder, 'top-left');
    document
        .getElementById('geocoder-container')
        .appendChild(geocoder.onAdd(map));
    document
        .querySelector('.mapboxgl-ctrl-geocoder--input')
        .addEventListener('focus', () => {
            geocoder.clear();
        });
    document.getElementsByClassName(
        'mapboxgl-ctrl-geocoder--input'
    )[0].placeholder = 'Search for a wine region, town, nation';
}
